<template>
  <transition-group name="list" class="lx-drag-list" tag="ul">
    <li v-for="(item, index) in curList" :key="item[columnKey]" class="lx-flex-row lx-drag-list-item" :draggable="isDrag && downIndex === index" @dragenter="dragenter($event, index)" @dragover="dragover($event, index)" @dragstart="dragstart(index)" @dragend="dragend($event)">
      <div class="lx-drag-list-item-middle lx-flex-grow-1 lx-flex-row lx-hidden" @click="doSelect(item)">
        <lx-check class="lx-flex-shrink-0" :name="item.key" :is-check="item.isCheck">
        </lx-check>
        <span class="lx-drag-list-item-title lx-flex-grow-1 lx-ml10 lx-mr10" :id="item.key">{{ item.name }}</span>
      </div>
      <div class="lx-drag-list-item-right lx-flex-shrink-0 lx-fz0" v-show="isDrag">
        <img class="icon-ham" src="./ham.png" alt="hamburg" draggable="false" @mousedown="mousedown(index)" @mouseleave="mouseleave(index)" @mouseup="mouseup">
      </div>
    </li>
  </transition-group>
</template>
<script>
import LxCheck from "@/components/LxCheck/index";
export default {
  name: "LxDragList",
  components: {
    LxCheck,
  },
  props: {
    list: {
      type: Array,
      default: () => [],
    },
    columnKey: {
      type: String,
      default: "columnId",
    },
    isDrag: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      curList: [],
      dragIndex: "",
      enterIndex: "",
      downIndex: "",
      time: null,
    };
  },
  watch: {
    list: {
      handler(val) {
        this.curList = val;
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    doSelect(curItem) {
      this.curList.forEach((item) => {
        if (item[this.columnKey] === curItem[this.columnKey]) {
          item.isCheck = !item.isCheck;
        }
      });
      this.$emit("result", this.curList);
    },
    dragstart(index) {
      this.dragIndex = index;
    },
    dragenter(e, index) {
      e.preventDefault();
      // 避免源对象触发自身的dragenter事件
      if (this.dragIndex !== index) {
        const source = this.curList[this.dragIndex];
        this.curList.splice(this.dragIndex, 1);
        this.curList.splice(index, 0, source);
        // 排序变化后目标对象的索引变成源对象的索引
        this.dragIndex = index;
      }
    },
    dragover(e) {
      e.preventDefault();
    },
    dragend(e) {
      e.preventDefault();
      this.$emit("result", this.curList);
    },
    mousedown(index) {
      this.downIndex = index;
      // if (this.time) return false;
      // this.time = setTimeout(() => {
      //     this.downIndex = index;
      // }, 300);
    },
    mouseup() {
      this.downIndex = "";
      // clearTimeout(this.time);
      // this.time = null;
    },
    mouseleave() {
      this.downIndex = "";
      // if (this.time) {
      //     clearTimeout(this.time);
      //     this.time = null;
      // }
    },
  },
};
</script>
<style lang="less" scoped>
.lx-drag-list-item {
  cursor: move;
  padding: 0 14px;
  border-bottom: 1px solid #f0f2f5;
  &:nth-child(odd) {
    background-color: #fff;
  }
  &:nth-child(even) {
    background-color: #fafafa;
  }
  &:last-child {
    border-bottom: none;
  }
  &:hover {
    background-color: #f5f6f7;
  }
  &.scale {
    position: relative;
    transform: translateY(5px) scale(1.1);
    box-shadow: 0 0 2px 3px rgba(0, 0, 0, 0.04);
    transition: all 0.3s ease;
    z-index: 1;
    color: #66b1ff;
  }
  .lx-drag-list-item-middle {
    height: 50px;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    cursor: default;
  }
  .lx-drag-list-item-right,
  .lx-drag-list-item-title {
    cursor: default;
    -webkit-user-select: none;
    -moz-user-select: none;
    -o-user-select: none;
    user-select: none;
  }
}
.icon-ham {
  width: 30px;
  height: 30px;
  cursor: move;
}
// .list-move {
//     transition: all 0.2s ease;
// }
</style>